const headers = [
    { align: 'start', value: 'value' },
    { text: '', value: 'relations' },
    { text: '', value: 'actions' }
];
export default headers;
